/** Whether the shift note panel is open, from "Hand off" or from going off duty in Dialpad. */
import { useSyncExternalStore } from 'react';

let open = false;
const listeners = new Set<() => void>();
const set = (v: boolean) => {
  open = v;
  for (const fn of listeners) fn();
};

export const openShiftNote = () => {
  set(true);
};
export const closeShiftNote = () => {
  set(false);
};

export function useShiftNoteOpen(): boolean {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => open,
    () => open,
  );
}
